interface CloseCircleSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CloseCircleSVG = ({ color, style }: CloseCircleSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
  >
    <circle cx="21" cy="21" r="19.5" stroke="#7C7C7C" strokeWidth="3" />
    <path
      d="M13.2002 12.6001L29.4002 28.8001"
      stroke="#7C7C7C"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
    <path
      d="M28.7998 12.6001L12.5998 28.8001"
      stroke="#7C7C7C"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
  </svg>
);

export default CloseCircleSVG;
